<template lang="pug">
  div.careers-header(:style="'--bg: url(' + require('@/assets/images/careers-header.jpeg') + ');'")
    b-container.h-100
      b-row(align-v="center").h-100
        b-col
          h1 A career at
            span.logo-text.ml-3 mktBI
          p.text-black-50
            | Our people are entrepreneurial at heart,
            br
            | on a mission to digitise private capital markets.
            br
            | Get in touch to discuss how you could kick start
            br
            | or accelerate a career in Private Capital, Software,
            br
            | Data, or Operations.
          b-button(size="sm" variant="primary" href="mailto:careers@mktbi.com") E-mail careers team

</template>

<script>
export default {
  name: "Header"
}
</script>

<style scoped lang="scss">
.careers {
  h2 {
    font-size: 40px;
    font-weight: 700;
    color: #364149;
  }
  &-header {
    background: var(--bg, rgb(247, 248, 251));
    background-position: 100% 50%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    position: relative;
    height: 590px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      background: rgb(247, 248, 252);
      background: linear-gradient(256deg, rgba(247, 248, 252, 0) 30%, rgba(247, 248, 252, 1) 50%);
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      @media(max-width: 640px) {
        background: linear-gradient(260deg, rgba(247, 248, 252, 0) 0%, rgba(247, 248, 252, 0.8) 120px);
      }
      @media(min-width: 1620px) {
        background: linear-gradient(256deg, rgba(247, 248, 252, 0) 30%, rgba(247, 248, 252, 1) 40%);
      }
    }


    @media(max-width: 640px) {
      background-size: cover;
      padding: 50px 0;

    }

    h1 {
      font-size: 50px;
      display: flex;
      padding: 50px 0 32px;
      font-weight: 700;

      img {
        height: 50px;
        margin-left: 15px;
      }

      @media(max-width: 640px) {
        font-size: 36px;
        img {
          height: 36px;
        }
      }
    }

    p {
      color: #767f86;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5;
      font-size: 24px;
      padding-bottom: 32px;
      @media(max-width: 640px) {
        font-size: 18px;
      }
    }

    .btn-primary {
      background: #5473e8;
      border-radius: 100px;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 18px;
      padding: 16px 28.8px;
      text-transform: uppercase;
      border: 0;
    }
  }
  &-list {
    > * {
      border-bottom: 1px solid #333;
      border-top: 0;
      border-left: 0;
      border-right: 0;
    }
  }
}
</style>